export const LOCALITY_TYPES = {
  city: 'Місто',
  town: 'Містечко',
  suburb: 'Передмістя',
  village: 'Село',
  hamlet: 'Хутір',
  station: 'Станція',
  settlement: 'Селище'
};
